













import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import { OrderStatus } from '~/models/marketplace/order'
import {
  orderPendingStatuses,
  orderFailStatuses,
  orderSuccessStatuses
} from '~/constants/marketplace'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { useI18n } from '~/compositions/i18n'
import { ciTimes } from '~/icons/source/regular/times'
import { ciCheckSimple } from '~/icons/source/solid/ciCheckSimple'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { CBadge },
  props: {
    status: {
      type: String as PropType<OrderStatus>,
      required: true
    }
  },
  setup(props) {
    const { status } = toRefs(props)
    const { t } = useI18n()

    const statusIcon = computed(() => {
      switch (status.value) {
        case OrderStatus.CANCELED_BY_SELLER:
        case OrderStatus.CANCELED_BY_USER:
        case OrderStatus.DECLINED:
          return ciTimes
        case OrderStatus.COMPLETED:
        case OrderStatus.RETURN_ACCEPTED:
          return ciCheckSimple
        default:
          return null
      }
    })

    const badgeVariant = computed(() => {
      if (orderSuccessStatuses.includes(status.value)) {
        return 'success'
      } else if (orderFailStatuses.includes(status.value)) {
        return 'danger'
      } else if (orderPendingStatuses.includes(status.value)) {
        return 'info'
      }
      return 'info'
    })

    return {
      statusIcon,
      badgeVariant,
      t
    }
  },
  i18n: defineComponentTranslations({
    pending_acceptance_order_status: {
      en: 'Pending acceptance',
      el: 'Εκκρεμεί αποδοχή'
    },
    accepted_order_status: {
      en: 'Accepted',
      el: 'Αποδεκτή'
    },
    pending_collection_of_items_order_status: {
      en: 'Product collection',
      el: 'Συλλογή προϊόντων'
    },
    pending_shipment_order_status: {
      en: 'Pending shipment',
      el: 'Αναμονή αποστολής'
    },
    shipped_order_status: {
      en: 'Shipped',
      el: 'Στάλθηκε'
    },
    canceled_by_user_order_status: {
      en: 'Cancelled by buyer',
      el: 'Ακυρώθηκε από αγοραστή'
    },
    canceled_by_seller_order_status: {
      en: 'Cancelled by seller',
      el: 'Ακυρώθηκε από πωλητή'
    },
    declined_order_status: {
      en: 'Declined',
      el: 'Απορρίφθηκε'
    },
    pending_delivery_order_status: {
      en: 'Pending delivery',
      el: 'Προς παράδοση'
    },
    ready_for_pickup_order_status: {
      en: 'Ready for pickup',
      el: 'Προς παραλαβή'
    },
    product_price: {
      en: 'Product price',
      el: 'Τιμή προϊόντος'
    },
    delivered_order_status: {
      en: 'Delivered',
      el: 'Παραδόθηκε'
    },
    could_not_be_delivered_order_status: {
      en: 'Νοt delivered',
      el: 'Δεν παραδόθηκε'
    },
    delivered_valid_for_return_order_status: {
      en: 'Delivered',
      el: 'Παραδόθηκε '
    },
    completed_order_status: {
      en: 'Completed',
      el: 'Ολοκληρώθηκε'
    },
    return_requested_order_status: {
      en: 'Return requested',
      el: 'Αίτημα επιστροφής'
    },
    return_accepted_order_status: {
      en: 'Being Returned',
      el: 'Προς επιστροφή'
    },
    return_declined_order_status: {
      en: 'Return declined',
      el: 'Απόρριψη επιστροφής'
    },
    returned_order_status: {
      en: 'Returned',
      el: 'Επιστράφηκε'
    },
    pending_payment_order_status: {
      en: 'Pending payment',
      el: 'Αναμονή πληρωμής'
    },
    acceptance_expired_order_status: {
      en: 'Acceptance expired',
      el: 'Η αποδοχή έληξε'
    }
  })
})
